// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperPreviewList-cls1_dR-","cls2":"PaperPreviewList-cls2_46m PaperPreviewList-cls1_dR-"};